import './PreviewSections.scss';
import state from '../../state';
import PreviewSectionItems from './PreviewSectionItems';

function PreviewSections() {
    let Sections = state.PreviewSections.map ((section, idx) =>
    {    
        return ( 
        <div  key={idx} className="preview_sections">
            <PreviewSectionItems  sectionInfo={section} />
        </div>
    )});
return (
    <div className='sectionList'>{Sections}</div>
)}
export default PreviewSections;